module.exports = __webpack_public_path__ + "img/aa7.17af3bc7.png";